<template>
  <div class="Tender" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-breadcrumb style=" background-color: #e9ecef78;">
                <b-breadcrumb-item href="#home">
                  <router-link to="/Assamese">
                      <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                      মূখ্যপৃষ্ঠা
                  </router-link>
                </b-breadcrumb-item>
               <b-breadcrumb-item href="#" active>নিবিদা</b-breadcrumb-item>
            </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw">
            <div class="cntnt">

          <div id="Fin1">
            <b-row>
              <b-col cols="12">
                  <h1 class="heading">বিগত বিত্তীয় বৰ্ষ <span id="finYear1"></span></h1>
              </b-col>
              <!-- <b-col cols="6" class="text-right">
                 <b-button variant="outline-info" style="margin-top: 1rem;" size="sm">
                   <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                   Download
                 </b-button>
              </b-col> -->
           </b-row>
           <p class="content">
              <b-table    :items="getTender" :fields="TenderPreviousfields">
                <template v-slot:cell(description)="data">
                 <span   v-html="data.value"></span>
                </template>
                <template v-slot:cell(tender_no)="data">
                 <span   v-html="data.value"></span>
                </template>
                <template v-slot:cell(important_dates)="data">
                  <span   v-html="data.value"></span>
                </template>
              </b-table>
            </p>
          </div>

          </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>



<script>
import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
import { mapGetters, mapActions } from 'vuex'
export default {

  components: {
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    },
  data() {
      return {
        TenderPreviousfields: [
          { key: 'description', label: 'Description',thStyle: {width: '40vw'} },
          { key: 'tender_no', label: 'Tender Number',thStyle: {width: '30vw'} },
          { key: 'important_dates', label: 'Important Dates',thStyle: {width: '20vw'} }
        ]
      }

  },
  computed:
  {
    ...mapGetters([
      'getTender'
    ])
  },
  methods: {
    ...mapActions([
      'retrieveTenderPrevious'
    ])
  },
  beforeMount() {
      if(this.getTender.length == 0) {
        this.retrieveTenderPrevious()
      }
  },
  mounted()
  {
  var d = new Date();
  var Year2 = d.getFullYear() - 1;
  var Year1 = Year2 -1;
//  document.getElementById("finYear").innerHTML = Year1+"-"+Year2;
  }
}
</script>

<style scoped="true">

.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }


li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.5rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}


table{
  text-align: left !important;
}
@media (max-width: 576px){
  .boxSize{
    width: 380px;
  }
  .table td{
    padding: .10rem;
  }
  .cntnt{
    box-shadow: none;
    padding:0px;
    width: 200vw;
  }
}
@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}
div{
    font-family: arial,Assamese_Font;
}
</style>
